<template>
    <el-aside width="100%">
        <el-input  
            placeholder="输入房间号进行搜索"
            v-model="filterText"
            clearable
        >
        </el-input>
        

        <!-- <el-tree
            class="filter-tree"
            :data="tableData"
            :props="{ label: 'name' }"
            default-expand-all
            :filter-node-method="filterNode"
            @node-click="handleNodeClick"
            ref="tree">
        </el-tree> -->

        <el-tree
            :data="tableData"
            :props="{ label: 'name' }"
            accordion
            node-key="id"
            :filter-node-method="filterNode"
			:default-expanded-keys="permTreeIds"
            @node-click="handleNodeClick"
            ref="tree"
            :render-content="renderContent"
        > 
        </el-tree>
    </el-aside>
</template>

<script>
import { getTree } from '@/apis/orange'
    export default {
        name: 'LocationTree',
        data() {
            return {
                tableData: [],
                permTreeIds: [1],
                filterText: '',
            }
        },
		created() {
			this.getLocationTree()
		},
        watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			}
		},
        methods: {
            getLocationTree() {
                const loading = this.$loading({
					text: '加载中...',
				});
                getTree().then(res => res.data).then(res => {
					this.tableData = res.data
                    loading.close()
                })
			},
            filterNode(value, data) {
				if (!value) return true;
				return data.name.indexOf(value) !== -1;
			},
			handleNodeClick(data) {
                this.$emit('getTreeData', data);
			},
            renderContent(h, { node, data, store }) {
                // 默认内容
                const children = [
                    h('span', [data.name])
                ];
                // 判断名称
                if (data.name === '南区' || data.name === '北区') {
                    children.push(
                        h('el-button', {
                            props: {
                                type: 'text',
                                icon: 'el-icon-plus',
                                size: 'mini'
                            },
                            attrs: {
                                title: '新增楼栋'
                            },
                            style: { marginLeft: '8px' },
                            on: {
                                click: (event) => {
                                    event.stopPropagation();
                                    this.$emit('addNode', data);
                                }
                            }
                        })
                    );
                }
                // 如果父节点是南区或北区，显示修改和删除按钮
                if (node.parent && (node.parent.data.name === '南区' || node.parent.data.name === '北区')) {
                    children.push(
                        h('el-button', {
                            props: {
                                type: 'text',
                                icon: 'el-icon-plus',
                                size: 'mini'
                            },
                            attrs: {
                                title: '新增房间'
                            },
                            style: { marginLeft: '8px' },
                            on: {
                                click: (event) => {
                                    event.stopPropagation();
                                    this.$emit('addRoom', data);
                                }
                            }
                        }),
                        h('el-button', {
                            props: {
                                type: 'text',
                                icon: 'el-icon-edit',
                                size: 'mini'
                            },
                            attrs: {
                                title: '修改楼栋'
                            },
                            style: { marginLeft: '8px', color: 'orange' },
                            on: {
                                click: (event) => {
                                    event.stopPropagation();
                                    this.$emit('editNode', data);
                                }
                            }
                        }),
                        h('el-button', {
                            props: {
                                type: 'text',
                                icon: 'el-icon-delete',
                                size: 'mini'
                            },
                            attrs: {
                                title: '删除楼栋'
                            },
                            style: { marginLeft: '4px', color: 'red' },
                            on: {
                                click: (event) => {
                                    event.stopPropagation();
                                    this.$emit('deleteNode', data);
                                }
                            }
                        })
                    );
                }
                return h('span', children);
            }
        }
    } 
</script>

<style scoped >
	
</style>